export const fhbLangAr = {
    ticketFhb: {
        usePage: "use page",
        verifyDistribution: "phone verify distribution",
        urgeDistribution: "urge distribution",
        staffMaxDailyWorkingNumber: "staff max daily working number ",
        ticketMaxWorkingNumber: "ticket max working number",
        ticketPartialCompletedWorkloadFactor: "ticket partial completed workload factor",
        ticketID: "Ticket ID",
        verifyCompleteTime: "verify Complete Time",
        ticketHandle: "ticket handle",
        ticketList: "ticket list",
        waitingProcess: "waiting process",
        partialCompleted: "partial completed",
        phoneVerifyDistribution: "phone verify distribution",
        distributionManagement: "Distribution Management",
        phoneVerify: "phone verify",
        stopAcceptTicket: "stop working",
        continueAcceptTicket: "start working",
        qualityInspectionResults: "quality inspection results",
        auditResults: "audit results",
        creditReviewResults: "audit results",
        auditType: "audit type",
        createTime: "Create Time",
        TicketCategory: "Information Auditing Ticket Type",
        IndividualDeductibleAmount: "the individual relief amount",
        GroupDeductibleAmount: "the group relief amount"
    },
    menuFhb: {
        creditApprovalTicketHandle: "Information Auditing Ticket  Handle",
        auditStaffManagement: "audit ticket management",
        ticketHandle: "work order processing",
        qualityInspectionTicketHandle: "quality inspection ticket handle",
        workOrderProcessingList: "Work Order Processing List"
    },
    robotFhb: {
        taskManagement: "task management",
        robotService: "robot service",
        robot: "robot",
        employeeType: "employee type",
        remainingToBeRepaidAmount: "remaining to be repaid amount",
        taskName: "task name",
        stratetyName: "stratety name",
        startTime: "start time",
        Time: "start time - end time",
        operator: "operator",
        timeSlot: "time slot",
        executionTime:"وقت التنفيذ",
        morning: "morning",
        afternoon: "afternoon",
        details: "detail",
        DistinguishingMode: "distinguishing mode"
    },
    messageFhb: {
        selectLanguage: "select language"
    }
};
